<template>
  <tr>
    <td v-if="modalItem.modulo == 'EN'" class="text-center">{{ row.codigoEndose }}</td>
    <td class="text-center">{{ row.fecha | date }}</td>
    <td>{{ row.servicio }}</td>
    <td>{{ row.hotel }}</td>
    <td class="text-center">{{ row.servicioTipo }}</td>
    <td class="text-center">
      <template v-if="mode == 'normal'">{{ row.moneda }}</template>
    </td>
    <td class="text-center">
      <template v-if="mode == 'normal'">{{ row.tarifa | number(2) }}</template>
      <InputText
        v-else
        v-model="row.tarifa"
        :vid="`tarifa_${row.idLiquidacionDetalle}`"
        name="Tarifa"
        rules="required|number"
        input-class="form-control form-control-table text-center"
      ></InputText>
    </td>
    <td>
      <template v-if="mode == 'normal'">{{ row.observaciones }}</template>
      <InputTextArea
        v-else
        v-model="row.observaciones"
        :vid="`observaciones_${row.idLiquidacionDetalle}`"
        name="Observaciones"
        input-class="form-control form-control-table"
      ></InputTextArea>
    </td>
  </tr>
</template>

<script>
import InputText from "../../shared/components/InputText.vue";
import InputTextArea from "../../shared/components/InputTextArea.vue";
export default {
  components: { InputTextArea, InputText },
  props: {
    row: Object,
    mode: String,
    modalItem: Object
  },
};
</script>

<style></style>
